import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-273b60c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-6 regist-h" }, "コード入力")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-small" }, [
    /*#__PURE__*/_createTextVNode(" 不正アクセス防止のため、メールアドレス宛に認証メールを送付しました。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("メール内の認証コードをご入力ください。 ")
  ])
], -1))
const _hoisted_3 = { class: "row justify-content-center mt-4" }
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "error-message" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"row mt-2\" data-v-273b60c6><div class=\"col-12 warn\" data-v-273b60c6> ※注意<br data-v-273b60c6> 30分以内にメールが届かない場合は、入力されたメールアドレスが間違っている可能性があります。前の画面に戻り、再度メールアドレスをご入力ください。 </div></div><div class=\"row justify-content-center mt-3\" data-v-273b60c6><div class=\"col-12 text-center\" data-v-273b60c6><button type=\"submit\" class=\"btn btn-primary\" data-v-273b60c6>認証</button></div></div>", 2)
const _hoisted_8 = { class: "row justify-content-center mt-4" }
const _hoisted_9 = { class: "col-12 text-center" }
const _hoisted_10 = { class: "row justify-content-center mt-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center modal-header" }, " 認証コードエラー ", -1))
const _hoisted_12 = { class: "col-12 text-center" }
const _hoisted_13 = { class: "col-12 text-center" }

import { Member } from '@/models';
import { DataStore } from 'aws-amplify';
import {ref, reactive, inject, onMounted, toRefs} from 'vue'
import { useRouter } from 'vue-router';
import { useCookies } from 'vue3-cookies';
import { useField, useForm } from "vee-validate";
import Modal from '../../components/Modal.vue'
import * as yup from "yup";

interface Props {
  member: Member;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null
  },
  emits: ['stopLoading', 'startLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
}



const { member } = toRefs(props);

const {cookies} = useCookies();
const router = useRouter();



const api: any = inject('api');

const formSchema = yup.object({
  code: yup.string().required('必須項目です').matches(/^[0-9]+$/i, '形式が間違っています'),
})

const {errors, meta, handleSubmit} = useForm({ validationSchema: formSchema })

const { value: code } = useField<string>("code");

const message = ref('');
const email = ref('');

const retry = async() => {
  emit('startLoading');
  try {
    email.value = cookies.get('verify_email');

    const code = await api.getRegistrationCode(email.value);
    await api.sendMail({
      email: email.value, 
      code: code.toString()
    });
  }
  catch(e) {
    console.log(e);
  }
  message.value = 'メールを再送しました';
  emit('stopLoading');
}

const submitHandler = handleSubmit(async() => {
  emit('startLoading');
  try {
    email.value = cookies.get('verify_email');

    const regCode = await api.verifyRegistrationCode(code.value);
    if (!regCode || regCode.email != email.value) {
      message.value = '認証コードが間違っています。';
      emit('stopLoading');
      return;
    }
    else if ((new Date(regCode.expiredAt)).getTime() < (new Date()).getTime()) {
      message.value = '認証コード入力時間を超過しています。30分以内に入力してください。';
      emit('stopLoading');
      return;
    }
    else {
      cookies.set('verify_code', code.value.toString());
      router.push('./form');
    }
  }
  catch(e) {
    console.log(e);
    emit('stopLoading');
  }
});

onMounted(() => {
  emit('stopLoading');
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(submitHandler) && _unref(submitHandler)(...args)))
    }, [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "text-center",
            maxlength: "6",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(code) ? (code).value = $event : null))
          }, null, 512), [
            [_vModelText, _unref(code)]
          ]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(errors).code), 1)
        ])
      ]),
      _createElementVNode("div", { class: "row mt-2" }, [
        _createElementVNode("div", { class: "col-12 text-center" }, [
          _createElementVNode("span", {
            class: "retry",
            onClick: retry
          }, "認証メールを再送付する")
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-white btn-back",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/registration/mail')))
          }, "前の画面に戻る")
        ])
      ])
    ], 32),
    _createVNode(Modal, {
      visible: message.value != '',
      onHide: _cache[4] || (_cache[4] = ($event: any) => (message.value = ''))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(message.value), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-white btn-back",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (message.value = ''))
            }, "閉じる")
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})